export const DISABLE_BLUR_ATTR = 'data-ws-disable-blur';
export const COMMENT_NODE_ATTRIBUTE_NAME = 'data-ws-type';
export const COMMENT_NODE_ATTRIBUTE_VALUE = 'ws-nested-comment';
